<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/G8yPOa/tc-custom/9780226810959.jpg?1722575498602" alt="This image is the cover for the book Django Generations"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Django Generations
      </h1>
      <p class="bookDescription body article font2">
        <b><i>Django Generations</i> shows how relationships between racial identities, jazz, and national belonging become entangled in France.</b><br/><br/> Jazz manouche—a genre known best for its energetic, guitar-centric swing tunes—is among France’s most celebrated musical practices of the twentieth and twenty-first centuries. It centers on the recorded work of famed guitarist Django Reinhardt and is named for the ethnoracial subgroup of Romanies (also known, often pejoratively, as “Gypsies”) to which Reinhardt belonged. French Manouches are publicly lauded as bearers of this jazz tradition, and many take pleasure and pride in the practice while at the same time facing pervasive discrimination. Jazz manouche uncovers a contradiction at the heart of France’s assimilationist republican ideals: the music is portrayed as quintessentially French even as Manouches themselves endure treatment as racial others.<br/><br/> In this book, Siv B. Lie explores how this music is used to construct divergent ethnoracial and national identities in a context where discussions of race are otherwise censured. Weaving together ethnographic and historical analysis, Lie shows that jazz manouche becomes a source of profound ambivalence as it generates ethnoracial difference and socioeconomic exclusion. As the first full-length ethnographic study of French jazz to be published in English, this book enriches anthropological, ethnomusicological, and historical scholarship on global jazz, race and ethnicity, and citizenship while showing how music can be an important but insufficient tool in struggles for racial and economic justice.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Siv B. Lie
      </h2>
      
      <p class="authorDescription body article"><B>Siv B. Lie</B> is assistant professor of music at the University of Maryland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a1c36610